import React, { memo, FC } from "react";
import { useStore } from "../../store/store";
import FixedPanelProfiles from "./FixedPanelProfiles";
import SwingProfiles from "./SwingProfiles";
import BifoldProfiles from "./BifoldProfiles";

const StilesRailsProfile: FC = () => {
  const doorType = useStore((state) => state.quote.doorType);

  if(doorType?.includes("Bi-fold")){
    return <BifoldProfiles/>
  }

  const isWindow = doorType?.includes("Window")

  if(doorType === "Fixed Panel"){
    return <FixedPanelProfiles />
  }
 
  if(doorType === "Swing" || isWindow){
    return <SwingProfiles isWindow={isWindow} />
  }

  return null
};

export default memo(StilesRailsProfile);
